import React from 'react';
import { Phone, CheckCircle, Wrench, Info } from 'lucide-react';
export function LiftgateInfoPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-4576">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-4577">
        <div className="container mx-auto px-4" data-id="element-4578">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-4579">
            LIFTGATE SERVICE
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-4580">
            Complete Sales, Service & Maintenance
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-4581">
        <div className="max-w-4xl mx-auto" data-id="element-4582">
          {/* Conventional Liftgates */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4583">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4584">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-4585" />
              Conventional Liftgates
            </h2>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-6" data-id="element-4586">
              <p className="text-gray-700 flex items-start" data-id="element-4587">
                <Info className="mr-3 flex-shrink-0 mt-1 text-blue-600" size={20} data-id="element-4588" />
                <span data-id="element-4589">
                  These are the first type of liftgate design invented
                </span>
              </p>
            </div>

            <div className="space-y-4" data-id="element-4590">
              <div className="flex items-start" data-id="element-4591">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4592" />
                <p className="text-gray-700" data-id="element-4593">
                  Mount to the chassis frame of a truck or trailer (usually a
                  straight truck)
                </p>
              </div>

              <div className="flex items-start" data-id="element-4594">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4595" />
                <p className="text-gray-700" data-id="element-4596">
                  Store in a position against the rear doorway
                </p>
              </div>

              <div className="flex items-start" data-id="element-4597">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4598" />
                <p className="text-gray-700" data-id="element-4599">
                  Often used on stake bed trucks to provide a lifting device and
                  a tailgate at the same time
                </p>
              </div>

              <div className="flex items-start" data-id="element-4600">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4601" />
                <p className="text-gray-700" data-id="element-4602">
                  Platforms are generally of the 'ramp ride' design
                </p>
              </div>

              <div className="flex items-start" data-id="element-4603">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4604" />
                <p className="text-gray-700" data-id="element-4605">
                  A level ride can be provided although special consideration
                  must be given to accomplish a ramp that will touch the ground
                  if needed
                </p>
              </div>

              <div className="flex items-start" data-id="element-4606">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4607" />
                <p className="text-gray-700" data-id="element-4608">
                  A pivoting ramp (such as an aluminum retention ramp) can be
                  considered for ground contact
                </p>
              </div>
            </div>
          </div>

          {/* Pickup Truck Models */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4609">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4610">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-4611" />
              Pickup Truck Models
            </h2>

            <div className="space-y-4" data-id="element-4612">
              <div className="flex items-start" data-id="element-4613">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4614" />
                <p className="text-gray-700" data-id="element-4615">
                  Typically mounted on pickup trucks
                </p>
              </div>

              <div className="flex items-start" data-id="element-4616">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4617" />
                <p className="text-gray-700" data-id="element-4618">
                  Same design is often modified (made wider with higher truck
                  floor ability) to be used on high cube vans, stake beds and
                  utility bodies
                </p>
              </div>

              <div className="flex items-start" data-id="element-4619">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4620" />
                <p className="text-gray-700" data-id="element-4621">
                  Platforms fold up vertically in the stored position as a
                  tailgate
                </p>
              </div>

              <div className="flex items-start" data-id="element-4622">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4623" />
                <p className="text-gray-700" data-id="element-4624">
                  Basically a 'level ride' design like RailTrac models but move
                  in an arching movement as do TuckUnders and Conventionals
                </p>
              </div>

              <div className="flex items-start" data-id="element-4625">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4626" />
                <p className="text-gray-700" data-id="element-4627">
                  Normally mounted to the truck vertical posts and the truck bed
                  rear edge
                </p>
              </div>

              <div className="flex items-start" data-id="element-4628">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4629" />
                <p className="text-gray-700" data-id="element-4630">
                  On stake truck beds a gusset is often used and attached to the
                  truck floor sides to create a corner post reinforcement for
                  the liftgate
                </p>
              </div>
            </div>
          </div>

          {/* FLIPAWAY / TuckUnder Models */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4631">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4632">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-4633" />
              FLIPAWAY / TuckUnder Models
            </h2>

            <div className="space-y-4" data-id="element-4634">
              <div className="flex items-start" data-id="element-4635">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4636" />
                <p className="text-gray-700" data-id="element-4637">
                  Mount to the chassis frame of a truck or trailer
                </p>
              </div>

              <div className="flex items-start" data-id="element-4638">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4639" />
                <p className="text-gray-700" data-id="element-4640">
                  Tuck and store underneath the rear of the truck or trailer
                </p>
              </div>

              <div className="flex items-start" data-id="element-4641">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4642" />
                <p className="text-gray-700" data-id="element-4643">
                  In the stored or tucked position they provide unobstructed
                  access to the truck or trailer doorway
                </p>
              </div>

              <div className="flex items-start" data-id="element-4644">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4645" />
                <p className="text-gray-700" data-id="element-4646">
                  Typically a 'ramp ride' design but may be specified as a
                  'level ride' for certain models and applications
                </p>
              </div>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 mt-6" data-id="element-4647">
              <h3 className="font-bold text-gray-900 mb-3" data-id="element-4648">
                Design Types Explained:
              </h3>

              <div className="space-y-3" data-id="element-4649">
                <div data-id="element-4650">
                  <p className="font-semibold text-gray-900" data-id="element-4651">Ramp Ride:</p>
                  <p className="text-gray-700" data-id="element-4652">
                    The platform is basically level at the truck floor position
                    and it then ramps down gradually as it approaches and then
                    touches the ground. The ramp edge is therefore touching the
                    ground at that point.
                  </p>
                </div>

                <div data-id="element-4653">
                  <p className="font-semibold text-gray-900" data-id="element-4654">Level Ride:</p>
                  <p className="text-gray-700" data-id="element-4655">
                    TuckUnder platform ramp edge may not touch the ground at the
                    fully lowered position and may need a pivoting ramp in order
                    to touch the ground.
                  </p>
                </div>

                <div data-id="element-4656">
                  <p className="font-semibold text-gray-900" data-id="element-4657">Movement:</p>
                  <p className="text-gray-700" data-id="element-4658">
                    The platform moves in an arch from the truck floor to the
                    ground and the ground to the truck floor.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Services Summary */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4659">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-4660">
              Complete Liftgate Services
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-4661">
              <div className="text-center" data-id="element-4662">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-4663">
                  <Wrench className="text-blue-600" size={32} data-id="element-4664" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-4665">Sales</h3>
                <p className="text-gray-700" data-id="element-4666">
                  All liftgate types and models for your commercial needs
                </p>
              </div>

              <div className="text-center" data-id="element-4667">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-4668">
                  <CheckCircle className="text-green-600" size={32} data-id="element-4669" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-4670">
                  Service
                </h3>
                <p className="text-gray-700" data-id="element-4671">
                  Expert repair and service for all liftgate systems
                </p>
              </div>

              <div className="text-center" data-id="element-4672">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-4673">
                  <Info className="text-purple-600" size={32} data-id="element-4674" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-4675">
                  Maintenance
                </h3>
                <p className="text-gray-700" data-id="element-4676">
                  Preventative maintenance to keep your liftgate operating
                  smoothly
                </p>
              </div>
            </div>
          </div>

          {/* Liftgate Types Summary */}
          <div className="bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg shadow-md p-8 mb-8" data-id="element-4677">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-4678">
              Liftgate Types We Service
            </h2>

            <div className="grid md:grid-cols-3 gap-4" data-id="element-4679">
              <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-4680">
                <h3 className="font-bold text-[#B1050B] mb-2" data-id="element-4681">Conventional</h3>
                <p className="text-sm text-gray-700" data-id="element-4682">
                  First design invented, mounts to chassis frame, stores against
                  rear doorway
                </p>
              </div>

              <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-4683">
                <h3 className="font-bold text-[#B1050B] mb-2" data-id="element-4684">Pickup Truck</h3>
                <p className="text-sm text-gray-700" data-id="element-4685">
                  Vertical fold-up design, level ride with arching movement
                </p>
              </div>

              <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-4686">
                <h3 className="font-bold text-[#B1050B] mb-2" data-id="element-4687">
                  FLIPAWAY / TuckUnder
                </h3>
                <p className="text-sm text-gray-700" data-id="element-4688">
                  Stores underneath, unobstructed doorway access
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-4689">
            <h2 className="text-3xl font-bold mb-4" data-id="element-4690">
              Expert Liftgate Sales, Service & Maintenance
            </h2>
            <p className="text-xl mb-6" data-id="element-4691">
              Complete solutions for all liftgate types and models
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-4692">
              <Phone className="mr-3" size={24} data-id="element-4693" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-4694">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}